import { PDF_DOWNLOAD_ICON, PDF_DOWNLOAD_LABEL } from '../../shared/pdfDownload';
export function PdfDownloadIcon() {
  return <span className="pdf-download-icon" aria-hidden="true" dangerouslySetInnerHTML={{ __html: PDF_DOWNLOAD_ICON }} />;
}
export function PdfDownloadButton({ href }: { href: string }) {
  return <a className="btn btn-pdf" href={href} target="_blank" rel="noopener noreferrer"><PdfDownloadIcon />{PDF_DOWNLOAD_LABEL}</a>;
}
